"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPPER = void 0;
exports.UPPER = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:UPPER not implemented');
    },
};
//# sourceMappingURL=upper.js.map